// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".spinner{margin:.25rem auto;width:2rem;height:2rem}", "",{"version":3,"sources":["loadingSpinner.scss"],"names":[],"mappings":"AAAA,SACE,kBAAoB,CACpB,UAAW,CACX,WACF","file":"loadingSpinner.scss","sourcesContent":[".spinner {\n  margin: 0.25rem auto;\n  width: 2rem;\n  height: 2rem;\n}"]}]);
// Exports
module.exports = exports;
